<template>
  <div class="text-center p-3 rounded-lg bg-gray-50 transition-all duration-200 hover:bg-gray-100">
    <div
      class="font-bold tabular-nums"
      :class="[sizeClass, colorClass]"
    >
      {{ displayValue }}
    </div>
    <div class="text-xs text-gray-500 mt-1">{{ label }}</div>
  </div>
</template>

<script>
export default {
  name: 'MetricCard',
  props: {
    value: {
      type: [Number, String],
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    format: {
      type: Function,
      default: null,
    },
    size: {
      type: String,
      default: 'md',
      validator: (val) => ['sm', 'md', 'lg'].includes(val),
    },
    color: {
      type: String,
      default: 'default',
      validator: (val) => ['default', 'info', 'success', 'warning', 'error', 'tangerine'].includes(val),
    },
  },
  computed: {
    displayValue() {
      if (this.format && typeof this.format === 'function') {
        return this.format(this.value)
      }
      return this.value
    },
    sizeClass() {
      const sizes = {
        sm: 'text-xl',
        md: 'text-2xl',
        lg: 'text-3xl',
      }
      return sizes[this.size] || sizes.md
    },
    colorClass() {
      const colors = {
        default: 'text-gray-900',
        info: 'text-primary-600',
        success: 'text-green-600',
        warning: 'text-amber-600',
        error: 'text-red-600',
        tangerine: 'text-primary-600',
      }
      return colors[this.color] || colors.default
    },
  },
}
</script>
